import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-down', 'ArrowUpDown', [["path",{"d":"M7.5 17.5v-11M4 10l3.5-3.5L11 10m5.5-3.5v11M13 14l3.5 3.5L20 14","key":"svg-0"}]]);